import { UsersEffects } from './users.effects';
import { CountriesEffects } from './countries.effects';
import { NotifyEffects } from './notify.effects';

export const generalEffects = [
  UsersEffects,
  CountriesEffects,
  NotifyEffects,
];
